import { render, staticRenderFns } from "./destroyUser.vue?vue&type=template&id=3d851960&scoped=true"
import script from "./destroyUser.vue?vue&type=script&lang=js"
export * from "./destroyUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d851960",
  null
  
)

export default component.exports